import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Validators, FormGroup, FormBuilder, NgForm } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { MultipleUserRegistrationService } from '../../service/apiservice/multipleuserregistration.service';
import { MulipleUserRegisterResDto } from '../../service/modal/MulipleUserRegisterResDto';
import { Globals } from '../../globals';

declare var $;
declare function info_noti(msg: any): any;
@Component({
  selector: 'app-multi-user-registration',
  templateUrl: './multi-user-registration.component.html',
  styleUrls: ['./multi-user-registration.component.css']
})
export class MultiUserRegistrationComponent implements OnInit {

 

    // multiUserForm: FormGroup;
    // submitted = false;
  
    file: File;
    @ViewChild('fileInput') fileInput: ElementRef;
    multipleUserRegisterResponse: MulipleUserRegisterResDto[] = new Array();
    constructor(private globals:Globals, private multiUserRegistration: MultipleUserRegistrationService, private spinner: NgxSpinnerService, private formBuilder: FormBuilder) { }
  
    ngOnInit() {
    }
    // loadEmptyUserRegistarationForm() {
    //   this.multiUserForm = this.formBuilder.group({
    //     'file': ['', Validators.required]
    //   })
    // }
  
    chooseFile($event) {
      let file = $event.target.files[0];
      this.file = file;
      // console.log(file);
      if(this.file.name.includes('.xlsx') || this.file.name.includes('.xlsm')
      || this.file.name.includes('.xltx') || this.file.name.includes('.xltm')){
       $("#fileexcel").html("");
      }else{
       $("#fileexcel").html("Please Choose Only Excel File");
      }
    }
    multipleUserRegister() {
      if (this.file == null || this.file == undefined) {
        $("#fileexcel").html("Please Select the Excel File");
        return;
      }
      debugger;
      this.spinner.show();
      this.multiUserRegistration.multipleUserExcelFile(this.file).subscribe((response) => {
        
        this.spinner.hide();
        // this.multipleUserRegisterResponse = response;
        this.multipleUserRegisterResponse = Array.from(new Set(response));
        if(this.multipleUserRegisterResponse.length==0){
          info_noti('User Register Successfully');
        }
        console.log(this.multipleUserRegisterResponse);
        $("#fileexcel").html("");
        this.fileInput.nativeElement.value = "";
  
      },
        error => {
          this.spinner.hide();
          $("#fileexcel").html("");
          this.fileInput.nativeElement.value = "";
  
        })
  
    }
    cancelClick() {
     
      $("#fileexcel").html("");
      this.fileInput.nativeElement.value = "";
    }
    exportSampleFile(){
      window.open( this.globals.excelFilePath, '_self');
    }
    exportBlankFile(){
      window.open( this.globals.excelFilePathBlankFile, '_self');
    }
  }
  